import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import { IonContent, modalController, IonPage } from "@ionic/vue";
import { ref, onMounted, computed, toRefs } from "vue";
import { IFont } from "@/helpers/fonts";
import { getIcon } from "@/helpers/api";
import { IFile } from "@/modules/a.worksheets/stores/worksheetDataStore";
import WksMediaModalCarousel from "@/modules/a.worksheets/views/components/WksMediaModalCarousel.vue";
import { IFileResolved } from "@/modules/a.worksheets/helpers/useIFileResolver";
import { getViewerType, mimeTypeToExtension } from "@/globals/helpers/media/mimeTypeUtils";
import { useDeviceStatus } from "@/stores/deviceStatus";



export default /*@__PURE__*/_defineComponent({
  __name: 'WksMediaModal',
  props: {
  modalBoxTitle: String,
  selectedValue: String,
  rightButtonLabel: String,
  middleButtonLabel: String,
  leftButtonLabel: String,
  files: { type: Array<IFileResolved>, default: () => null },
  index: { type: Number, default: 0 },
  showDownloadIcon: { type: Boolean, default: false },
  enableWebCarousel: { type: Boolean, default: false },
},
  setup(__props) {

const { isWeb } = toRefs(useDeviceStatus());

const props = __props;

const dismiss = () => modalController.dismiss(null, "close");
const leftArrow = ref<string>();
const closeIcon = ref<string>();
const rotationIcon = ref<string>();
const downloadIcon = ref<string>();
const carousel = ref<InstanceType<typeof WksMediaModalCarousel> | null>(null);
onMounted(async () => {
  console.log("MODAL:", props.files)
  leftArrow.value = await getIcon("1010", "left_arrow");
  closeIcon.value = await getIcon("1010", "close");
  rotationIcon.value = await getIcon("1010", "rotate-right");
  downloadIcon.value = await getIcon("2105", "download");
});

const currentFile = computed(() => props.files?.[props.index] ?? props.files?.[0]);

async function downloadCurrent() {
  const file = currentFile.value;
  if (!file?.source) return;

  try {
    const response = await fetch(file.source);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const extension = file.type ? mimeTypeToExtension[file.type] : undefined;

    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = extension ? `download.${extension}` : "download";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Erro ao transferir o ficheiro:", error);
  }
}

const pointerStart = ref<{ x: number; y: number } | null>(null);

function onPointerDown(e: PointerEvent) {
  pointerStart.value = {
    x: e.clientX,
    y: e.clientY,
  };
}

function onPointerUp(e: PointerEvent) {
  if (!pointerStart.value) return;

  const diffX = Math.abs(e.clientX - pointerStart.value.x);
  const diffY = Math.abs(e.clientY - pointerStart.value.y);

  pointerStart.value = null;

  const moved = diffX > 8 || diffY > 8;

  if (moved) return;

  dismiss();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), {
    class: "modal-primary media-modal-page",
    onPointerdown: onPointerDown,
    onPointerup: onPointerUp
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), {
        "force-overscroll": !_unref(isWeb),
        class: "media-modal-content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "options",
            onPointerdown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
            onPointerup: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
            onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("img", {
              src: closeIcon.value,
              class: "close-icon",
              onClick: _withModifiers(dismiss, ["stop"])
            }, null, 8, _hoisted_1),
            (__props.files.every(f => _unref(getViewerType)(f.type) === 'image'))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (carousel.value?.rotate && carousel.value?.rotate(...args))),
                  src: rotationIcon.value
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true),
            (__props.showDownloadIcon && currentFile.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: downloadIcon.value,
                  onClick: _withModifiers(downloadCurrent, ["stop"])
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true)
          ], 32),
          _createVNode(WksMediaModalCarousel, {
            ref_key: "carousel",
            ref: carousel,
            files: __props.files,
            zoomable: true,
            initialSlide: __props.index,
            enableWebCarousel: __props.enableWebCarousel
          }, null, 8, ["files", "initialSlide", "enableWebCarousel"])
        ]),
        _: 1
      }, 8, ["force-overscroll"])
    ]),
    _: 1
  }))
}
}

})